import React, {useState} from "react"
import {IconChevronDown, IconChevronRight} from "@tabler/icons-react"
import {FilterCard} from "./FilterCard"
import {USE_FILTERS_STUB_DATA} from "@/utils/hooks/useStubFilters"
import {StubIndicator} from "@/components/common/StubIndicator"
import {useFilters} from "@/utils/hooks/useFilters"

export function RulesetTab() {
  const {data: filters, loading, error} = useFilters()
  const [isRulesetExpanded, setIsRulesetExpanded] = useState(true)

  const toggleRuleset = () => setIsRulesetExpanded(!isRulesetExpanded)

  return (
    <div className="mb-6 flex flex-1 flex-col overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm">
      {/* Header - stays fixed */}
      <div className="flex-shrink-0 p-4">
        <div
          className="flex cursor-pointer flex-row items-center justify-between"
          onClick={toggleRuleset}
        >
          <div className="flex items-center">
            {isRulesetExpanded ? (
              <IconChevronDown size={20} className="mr-2 text-gray-500" />
            ) : (
              <IconChevronRight size={20} className="mr-2 text-gray-500" />
            )}
            <h2 className="text-xl font-semibold">Archiving Ruleset</h2>
          </div>
          <StubIndicator featureName="filters" show={USE_FILTERS_STUB_DATA} />
        </div>

        {isRulesetExpanded && (
          <p className="mb-4 mt-2 text-sm text-gray-600">
            These rules determine how messages are processed in the system.
            Contact an administrator to modify ruleset settings.
          </p>
        )}
      </div>

      {/* Content - scrollable */}
      {isRulesetExpanded && (
        <div className="flex-1 overflow-auto px-4 pb-4 pt-2">
          {error ? (
            <div className="rounded-md bg-red-50 p-4 text-red-700">
              <p className="font-medium">Error loading ruleset</p>
              <p className="text-sm">{error.message}</p>
            </div>
          ) : loading ? (
            <p>Loading ruleset...</p>
          ) : filters.length === 0 ? (
            <p>No rules configured</p>
          ) : (
            <div className="transition-all duration-300">
              {filters.map((filter) => (
                <FilterCard key={filter.id} filter={filter} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
